// Operations Center — campaigns, calendar, outreach CRM, growth, procedures.
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { CampaignsTab } from "@/components/admin/OpsCampaigns";
import { CalendarTab, GrowthTab, OutreachTab, ProceduresTab } from "@/components/admin/OpsCenter";

export const Route = createFileRoute("/_authenticated/admin/ops")({
  component: OpsCenterPage,
  head: () => ({
    meta: [
      { title: "Operations Center | Buddha KA Admin" },
      {
        name: "description",
        content:
          "Campaign Center, content calendar, outreach CRM, growth dashboard, and operating procedures for KAfrequency.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});

const TABS = [
  { key: "campaigns", label: "Campaign Center" },
  { key: "calendar", label: "Content Calendar" },
  { key: "outreach", label: "Outreach CRM" },
  { key: "growth", label: "Growth" },
  { key: "sops", label: "Procedures" },
] as const;

type TabKey = (typeof TABS)[number]["key"];

function OpsCenterPage() {
  const [tab, setTab] = useState<TabKey>("campaigns");

  return (
    <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
      <header className="mb-8">
        <p className="text-xs uppercase tracking-[0.3em] text-gold">Admin</p>
        <h1 className="mt-2 font-serif text-3xl sm:text-4xl">Operations Center</h1>
        <p className="mt-3 max-w-2xl text-muted-foreground">
          The single desk for running KAfrequency: campaigns and their full rollout, the unified
          content calendar, outreach relationships, measured growth, and the standard procedures.
        </p>
      </header>

      <nav aria-label="Operations sections" className="mb-8 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            aria-current={tab === t.key ? "page" : undefined}
            className={`rounded-full border px-4 py-2 text-sm transition-colors ${
              tab === t.key ? "border-gold text-gold" : "hairline text-muted-foreground hover:text-foreground"
            }`}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {tab === "campaigns" && <CampaignsTab />}
      {tab === "calendar" && <CalendarTab />}
      {tab === "outreach" && <OutreachTab />}
      {tab === "growth" && <GrowthTab />}
      {tab === "sops" && <ProceduresTab />}
    </div>
  );
}
